import { FormControl, FormGroup, UntypedFormGroup } from '@angular/forms';
import { PersonalDetailsForm } from '../../models/personal-details/personal-details-form.interface';
import { mockGroupMarketingPreferencesForm } from '../group-marketing-preferences/group-marketing-preferences-form.mock';

export const mockPersonalDetailsForm: PersonalDetailsForm = {
  addProtectionPolicy: new FormControl(true, { nonNullable: true }),
  address: new UntypedFormGroup({
    id: new FormControl(),
    addressLine1: new FormControl(),
    addressLine2: new FormControl(),
    addressLine3: new FormControl(),
    addressLine4: new FormControl(),
    postalCode: new FormControl(),
    countryCode: new FormControl(),
    countryIso2: new FormControl(),
    countryIso3: new FormControl(),
    countryIsoNumber: new FormControl(),
    countryName: new FormControl(),
    type: new FormControl(),
    isOverrideAddress: new FormControl(),
  }),
  emailAddress: new FormControl(null),
  firstName: new FormControl(null),
  groupMarketingPreferences: new FormGroup(mockGroupMarketingPreferencesForm),
  lastName: new FormControl(null),
  marketingPreferenceEmail: new FormControl(true, { nonNullable: true }),
  marketingPreferencePost: new FormControl(true, { nonNullable: true }),
  marketingPreferenceTelephone: new FormControl(true, { nonNullable: true }),
  privacyPolicy: new FormControl(true, { nonNullable: true }),
  telephoneNumber: new FormControl(null),
  titleId: new FormControl(null),
};
